import React from "react";
import "../App.css";
import HomeButton from "./HomeButton";

const AboutUs = () => {
  return (
    <div className="main-content-wrapper fade-in-up">
      <HomeButton />
      <h1 className="aharoni-style" style={{ fontSize: '3em', marginBottom: '20px' }}>Over PlanSucces</h1>
      
      <div className="admin-card" style={{ maxWidth: '800px', textAlign: 'left', alignItems: 'flex-start', cursor: 'default' }}>
        <p>
          Welkom bij PlanSucces, het platform dat de brug slaat tussen ambitieuze rijscholen en hun leerlingen. 
          Wij geloven dat een goede rijopleiding begint bij een vlekkeloze planning. 
          Daarom hebben wij een omgeving gecreëerd waarin structuur, snelheid en overzicht centraal staan.
        </p>

        <h2 style={{ color: '#007bff', marginTop: '30px', alignSelf: 'center' }}>Waarom PlanSucces?</h2>
        <p>
          In de drukke agenda van een rijinstructeur telt elke minuut. PlanSucces is gebouwd om die kostbare tijd terug te geven. 
          Onze webapp fungeert als een digitaal controlecentrum:
        </p>

        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{ marginBottom: '15px' }}>
            <strong style={{ color: '#007bff' }}>Flexibiliteit voor de Instructeur:</strong> Als rijinstructeur kun je met enkele klikken afspraken aanpassen of annuleren. 
            Of het nu gaat om een verschuiving in de planning of een onvoorziene wijziging, je behoudt altijd de regie.
          </li>
          <li style={{ marginBottom: '15px' }}>
            <strong style={{ color: '#007bff' }}>Duidelijkheid voor de Leerling:</strong> Leerlingen zien in realtime de beschikbaarheid en hun eigen afspraken, 
            wat zorgt voor minder miscommunicatie en een professionele uitstraling van je rijschool.
          </li>
          <li style={{ marginBottom: '15px' }}>
            <strong style={{ color: '#007bff' }}>Maximale Efficiëntie:</strong> Door het gemakkelijke beheer van tijdsloten is je agenda altijd optimaal gevuld en voor beide partijen 100% overzichtelijk.
          </li>
        </ul>

        <h2 style={{ color: '#007bff', marginTop: '30px', alignSelf: 'center' }}>Transparant en Voordelig</h2>
        <p>
          Wij houden van simpel, ook in onze prijzen. Geen ingewikkelde staffels of dure abonnementen. 
          Waar leerlingen kosteloos profiteren van het overzicht en gemak, vragen wij van de rijinstructeur een kleine bijdrage voor het volledige digitale beheer.
        </p>
        <p>
          Gebruikmaken van de volledige service van PlanSucces kost voor de rijinstructeur slechts <strong>€ 5,00 per maand</strong>.
        </p>
        <p>
          Om er zeker van te zijn dat PlanSucces de juiste keuze is voor jouw rijschool, bieden wij de <strong>eerste 15 dagen volledig gratis</strong> aan. 
          Zo kun je zonder risico ontdekken hoe onze webapp je dagelijkse planning vereenvoudigt voordat je abonnement definitief start.
        </p>
        <p>
          Hiervoor krijg je als professional toegang tot het volledige Instructeurs Pakket, inclusief alle beheerfuncties voor je agenda en leerlinginteracties.
        </p>

        <p style={{ marginTop: '30px', fontWeight: 'bold', fontSize: '1.2em', textAlign: 'center', color: '#fff', width: '100%' }}>
          Kies voor rust in je planning. Kies voor PlanSucces.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
